import styled from 'styled-components';

const Form = styled.form`
   position: relative;
`;

export default Form;
